import React from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import image1 from "../assets/image1.jpg";

const TermsConditions: React.FC = () => {
  return (
    <div className="min-w-screen bg-[#141237]">
      <div className="flex w-full flex-col items-center justify-center gap-12 px-4 py-16">
        <Navbar />

        {/* Hero Section */}
        <section className="relative text-center text-white py-16 rounded-xl shadow-lg px-6 md:px-12 overflow-hidden w-full max-w-4xl">
          <img
            src={image1}
            alt="Finance background"
            className="absolute inset-0 w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#141237]/80 via-[#FF2D55]/20 to-[#141237]/80 rounded-xl"></div>
          <div className="relative z-10">
            <h1 className="text-4xl sm:text-5xl font-bold mb-4 drop-shadow-lg">
              Terms & Conditions
            </h1>
            <p className="text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed drop-shadow-md mt-4">
              Welcome to <span className="font-semibold">{import.meta.env.VITE_COMPANY_NAME}</span>, By
              accessing and using our website or applying for any of our loan
              products, you agree to comply with these terms.
            </p>
          </div>
        </section>

        {/* Terms Content */}
        <div className="max-w-4xl w-full mx-auto p-8 bg-white rounded-xl shadow-md text-gray-800 space-y-6">
          {[
            {
              title: "1. Introduction",
              content:
                `${import.meta.env.VITE_COMPANY_NAME} provides personal loans to salaried individuals under the regulatory oversight of ${import.meta.env.VITE_COMPANY_NBFC} Our goal is to offer instant, easy, and transparent financial solutions.`,
            },
            {
              title: "2. Eligibility Criteria",
              content:
                "To apply for a personal loan, you must meet the following requirements:",
              list: [
                "Be at least 22 years old and not older than 55 at the time of application.",
                "Be a salaried individual with stable income from a recognized organization.",
                `Meet the minimum monthly income criteria defined by ${import.meta.env.VITE_COMPANY_NBFC}`,
                "Be a resident of India with a satisfactory credit score and financial history.",
              ],
            },
            {
              title: "3. Loan Application Process",
              content:
                `The process includes registration, application form, document submission, and credit assessment. Approval is solely at the discretion of ${import.meta.env.VITE_COMPANY_NBFC}`,
            },
            {
              title: "4. Loan Terms",
              content:
                "Loan amount, interest rate, and repayment schedule are determined based on applicant profile. Interest rate remains fixed during the tenure.",
            },
            {
              title: "5. Fees and Charges",
              content:
                "Applicable fees may include processing fee, late payment charges, Early repayment may attract prepayment penalties, etc., as mentioned in the loan agreement.",
            },
            {
              title: "6. Loan Disbursement",
              content:
                `Once approved and formalities completed, the loan amount will be credited to your bank account. Disbursement timelines may vary, but ${import.meta.env.VITE_COMPANY_NAME} strives for quick processing.`,
            },
            {
              title: "7. Loan Repayment",
              content:
                "Repayments must follow the schedule outlined in the loan agreement. Payments may be auto-debited via NACH or through digital methods such as UPI. Early repayment may attract foreclosure charges.",
            },
            {
              title: "8. Default and Consequences",
              content:
                "Failure to repay on time may lead to late fees, negative reporting to credit bureaus, and possible legal action.",
            },
            {
              title: "9. Cancellation of Loan",
              content:
                "Applications may be cancelled before disbursement. Once disbursed, cancellation is not possible. Prepayment is allowed as per agreement terms.",
            },
            {
              title: "10. Data Privacy and Security",
              content:
                "All information is handled securely in compliance with data protection laws and used only for loan processing and communication.",
            },
            {
              title: "11. User Responsibilities",
              content:
                "You must provide accurate details during registration and application. Misrepresentation may lead to denial of service or legal action.",
            },
            {
              title: "12. Amendments to Terms",
              content:
                "We may update these terms anytime. Updates will be posted on our website, and it is your responsibility to stay informed.",
            },
            {
              title: "13. Dispute Resolution",
              content:
                "Disputes will first be attempted to resolve amicably. If unresolved, they fall under the jurisdiction of courts in Delhi, India.",
            },
            {
              title: "14. Limitation of Liability",
              content:
                `${import.meta.env.VITE_COMPANY_NBFC} Ltd is not liable for any loss, damage, or inconvenience arising from the use of this website or services, except as expressly mentioned in the loan agreement.`,
            },
            {
              title: "15. Governing Law",
              content:
                "These Terms and Conditions are governed by and construed in accordance with the laws of India.",
            },
          ].map((item, idx) => (
            <div key={idx} className="space-y-2">
              <h2 className="text-2xl font-semibold text-[#FF2D55]">
                {item.title}
              </h2>
              <p className="text-gray-800">{item.content}</p>
              {item.list && (
                <ul className="list-disc list-inside text-gray-800 ml-4 space-y-1">
                  {item.list.map((li, i) => (
                    <li key={i}>{li}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default TermsConditions;
